import { xenv, isHK, trackEvent, build } from '@didi/webx-js'
import { GlobalConfig } from '../../config'
import { GlobalEnv } from '../../global_env'
import { URLQueries } from '../../global_env/url_query'

export const commonParams = {
  env: isHK ? 'HK' : 'China',
}

export const pretreatEnv = () => {
  return xenv()
}

/**
 * 商城支付封装
 * @param {Object} payInfo
 * @param {TPayOptions} options - 前端支付配置
 * @returns
 */
export const trackPayLog = (payInfo, options) => {
  const final_xenv = pretreatEnv()
  trackEvent('wyc_tech_quartz_order_pay_info_bt', '优惠商城订单支付校验', {
    // 交易类信息
    out_trade_id: payInfo.out_trade_id,
    order_id: options.orderId,
    appid:
      final_xenv === 'esapp'
        ? GlobalConfig.Pay.appid.esapp
        : payInfo.appid || URLQueries.getQuery('appid') || '',
    open_id:
      payInfo.open_id ||
      URLQueries.getQuery('open_id') ||
      URLQueries.getQuery('openId') ||
      URLQueries.getQuery('openid') ||
      '',
    uid: GlobalEnv.loginInfo.uid,
    // 环境信息
    xenv: xenv(),
    final_xenv,
    from: GlobalEnv.from,
    lang: GlobalEnv.lang,
    ...commonParams,
  })
}

export const dealHref = (pathname, url, params = {}) => {
  const matchPath = pathname.match(/^(.*).html.*/)
  const matchsgs = (url || window.location.href).match(/(.*)\/(.*)\.html*/)
  let endUrl = pathname
  if (matchPath && matchsgs) {
    endUrl = build(`${matchsgs[1]}/${pathname}`, params)
  }
  return endUrl
}
